// Centralised in-page smooth scroll that integrates with the Lenis instance
// (exposed on window.__lenis in App.js). Falls back to native scrolling.
export const NAV_OFFSET = -72;

export const scrollToId = (href) => {
  if (typeof document === "undefined") return;
  const el = document.querySelector(href);
  if (!el) return;

  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: NAV_OFFSET, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const scrollToTop = () => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(0, { duration: 1.2 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
